var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaiar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 235,
    viewBox: "0 0 235 235",
    width: 235,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#010101",
    height: 235,
    rx: 72,
    width: 235
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m126.493 117.923 74.469-39.8917-12.507-24.0313-68.224 27.5772c-1.752.7137-3.71.7137-5.462 0l-68.2239-27.5772-12.5451 24.1084 74.468 39.8916-74.468 39.892 12.5451 24.108 68.2239-27.789c1.752-.714 3.71-.714 5.462 0l68.224 27.654 12.545-24.108z",
    fill: "#2f64f6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiar);
export default __webpack_public_path__ + "static/media/maiar.5b1b972d78d84a5fc5e9bceea5de5fbd.svg";
export { ForwardRef as ReactComponent };